import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/usersGroups";

export const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter }, orderBy: "id desc" });
    return request(`${resource}/getList${query}`, { method: "GET" }, { countInHeaders: true });
};
export const getListForSelect = (params: {}) =>
    request(`${resource}/getListForSelect${containsQuery(params)}`, { method: "GET" });
export const getItem = (params: { id: number }) => request(`${resource}/get/${params.id}`, { method: "GET" });
export const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));
export const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));
export const addAllCars = (params: {}) => alertRequest(`${resource}/addAllCars`, body(params));
export const addCars = (params: {}) => alertRequest(`${resource}/addCars`, body(params));
export const getCarsList = ({ preparedFilter, groupId, ...params }: OdataFilters & { groupId: number }) => {
    const query = queryCollection(params, { filter: preparedFilter, orderBy: "carId desc" });
    return request(`${resource}/getCarsList/${groupId}${query}`, { method: "GET" }, { countInHeaders: true });
};
export const getGroupsCarList = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, orderBy: "carId desc" });
    return request(`${resource}/getGroupsCarList${query}`, { method: "GET" }, { countInHeaders: true });
};
export const removeAllCars = (params: {}) => alertRequest(`${resource}/removeAllCars`, body(params));
export const removeCars = (params: {}) => alertRequest(`${resource}/removeCars`, body(params));
export const getUsersList = ({ preparedFilter, groupId, ...params }: OdataFilters & { groupId: number }) => {
    const query = queryCollection(params, { filter: preparedFilter, orderBy: "userId desc" });
    return request(`${resource}/getUsersList/${groupId}${query}`, { method: "GET" }, { countInHeaders: true });
};
export const addUser = (params: {}) => alertRequest(`${resource}/addUser`, body(params));
export const removeUser = (params: {}) => alertRequest(`${resource}/removeUser`, body(params));
